import {
  initiateSingleCheckout,
  CheckoutOrderTypeMap,
  ExtraServiceOrderType,
} from '@marketplace-web/domain/checkout-data'

import { incrementCheckoutInitiate } from '../utils/observability'
import { navigateToSingleCheckout } from '../utils/utils'

const useNavigateToCheckout = () => {
  const navigateToCheckout = async (transactionId: number) => {
    const orderType = CheckoutOrderTypeMap[ExtraServiceOrderType.Transaction]

    incrementCheckoutInitiate({ orderType })

    const response = await initiateSingleCheckout({
      id: transactionId.toString(),
      type: orderType,
    })

    if ('errors' in response) {
      return null
    }

    return navigateToSingleCheckout(response.checkout.id, transactionId, orderType)
  }

  return { navigateToCheckout }
}

export default useNavigateToCheckout
